<template>
  <router-view />
</template>

<script setup lang="ts">
// App 根组件
</script>
